import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLikeFilled = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: props.color,
		d: "M11.7812 3.03125C12.5938 3.21875 13.125 4 12.9688 4.8125L12.875 5.15625C12.7188 6 12.4062 6.78125 12 7.5L16.5 7.5C17.3125 7.5 18 8.1875 18 9C18 9.59375 17.6562 10.0937 17.1875 10.3437C17.5312 10.625 17.75 11.0312 17.75 11.5C17.75 12.25 17.2188 12.8437 16.5312 13C16.6562 13.2187 16.75 13.4687 16.75 13.75C16.75 14.4375 16.3125 15 15.6875 15.1875C15.7188 15.2812 15.75 15.4062 15.75 15.5C15.75 16.3438 15.0625 17 14.25 17H11.1875C10.5938 17 10.0313 16.8438 9.53125 16.5L8.3125 15.7187C7.5 15.1562 7 14.2188 7 13.2188V12V10.5L7 9.75C7 8.8125 7.40625 7.96875 8.125 7.40625L8.34375 7.21875C9.15625 6.53125 9.75 5.625 9.9375 4.5625L10 4.21875C10.1875 3.40625 10.9688 2.875 11.7812 3.03125ZM3 8L5 8C5.53125 8 6 8.46875 6 9L6 16C6 16.5625 5.53125 17 5 17H3C2.4375 17 2 16.5625 2 16L2 9C2 8.46875 2.4375 8 3 8Z"
	})
});
const ForwardRef = forwardRef(SvgLikeFilled);
export default ForwardRef;
